import './App.css';
import LogIn from './components/auth/LogIn';
import Register from './components/auth/Register';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import HomePage from './components/HomePage';
import RoomsList from './components/RoomsList';
import TopMenu from './components/TopMenu';
import AppLayout from './components/AppLayout';
import GameRoom from './components/inGameLayout/GameRoom';
import Leaderboard from './components/Leaderboard';
import Settings from './components/Settings';
import Customize from './components/Customize';
import ProtectedRoute from './components/auth/ProtectedRoute';
import NotFoundRedirect from './components/auth/NotFoundRedirect';



const router = createBrowserRouter( [
  {
    path: "/",
    element: <AppLayout />,
    children: [
      { index: "true", element: <LogIn /> },
      { path: "register", element: <Register /> },
      {
        element: <ProtectedRoute />,
        children: [
          { path: "home", element: <HomePage /> },
          { path: "rooms", element: <RoomsList /> },
          { path: "leaderboard", element: <Leaderboard /> },
          { path: "settings", element: <Settings /> },
          { path: "customize", element: <Customize /> },
          { path: "topmenutest", element: <TopMenu /> },
          { path: "gameroomtest", element: <GameRoom />},
        ],
      },
      // Unknown paths: authenticated users go to /home, everyone else to login.
      { path: "*", element: <NotFoundRedirect /> },

    ]

  }

]);

function App() {
  return (
    <div className="App">
      <RouterProvider router={router} />
  
    </div>
  );
}

export default App;
